module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Medição' : 'Editar Medição',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "isModal": false,
      "onSave": this.salvar,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "ltcat-medicao",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações Gerais\n        ")]), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Replicar Medição para os Seguintes GHE",
      "items": _vm.config.list.replicar,
      "multiple": ""
    },
    model: {
      value: (_vm.formData.replicar),
      callback: function($$v) {
        _vm.$set(_vm.formData, "replicar", $$v)
      },
      expression: "formData.replicar"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Fator de Risco",
      "name": "id_tab.id",
      "items": _vm.config.list.id_age,
      "remote": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFatorRisco
    },
    model: {
      value: (_vm.formData.id_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_age", $$v)
      },
      expression: "formData.id_age"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Tabela Dinâmica",
      "name": "id_age.id",
      "items": _vm.config.list.id_tab,
      "itemText": "tabela_dinamica",
      "is-object": ""
    },
    model: {
      value: (_vm.formData.id_tab),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_tab", $$v)
      },
      expression: "formData.id_tab"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Nº de Amostragens Necessárias por Ponto",
      "type": "number"
    },
    model: {
      value: (_vm.formData.amostragem),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amostragem", $$v)
      },
      expression: "formData.amostragem"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left",
    attrs: {
      "label": "Data Medição"
    },
    model: {
      value: (_vm.formData.data_medicao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_medicao", $$v)
      },
      expression: "formData.data_medicao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Equipamentos\n        ")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('ed-alert', [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('a', {
    attrs: {
      "href": "http://caepi.mte.gov.br/internet/ConsultaCAInternet.aspx",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Clique aqui para consultar a lista de CA\n                      ")])])])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0 text-left ",
    attrs: {
      "label": "Pesquisar Equipamento",
      "placeholder": "Digite o nome do EPI",
      "items": _vm.config.list.epi,
      "loading": _vm.config.loading.epi,
      "itemText": "epi",
      "maxLenght": "10",
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEquipamento,
      "input": _vm.addEPI
    },
    model: {
      value: (_vm.formData.epi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "epi", $$v)
      },
      expression: "formData.epi"
    }
  })], 1)])]), _vm._v(" "), (_vm.formData.equipamentos && _vm.formData.equipamentos.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("EPI")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Med. Protecao \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi tentada a implementação de medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo EPI por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Cond. Funcionamento \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foram observadas as condições de funcionamento do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Uso Ininterrupto \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o uso ininterrupto do EPI ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Validade \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Foi observado o prazo de validade do CA no momento da compra do EPI?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    }
  }, [_c('b', [_vm._v("\n                  Troca \n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais, comprovada mediante recibo assinado pelo usuário em época própria?"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#cccccc",
      "border-top": "solid 1px #cccccc"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("\n                  Higienização\n                  "), _c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "É observada a higienização conforme orientação do fabricante nacional ou importador?"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.formData.equipamentos), function(equipamento, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_vm._v("\n                " + _vm._s(equipamento.epi.nome) + "\n                \n                "), (equipamento.epi.ca) ? _c('span', [_c('br'), _c('b', [_vm._v("CA:")]), _vm._v(" " + _vm._s(equipamento.epi.ca) + "\n                ")]) : _vm._e(), _vm._v(" "), (equipamento.epi.categoria) ? _c('span', [_c('br'), _c('b', [_vm._v("Categoria:")]), _vm._v(" " + _vm._s(equipamento.epi.categoria.nome) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "medProtecao"
      },
      model: {
        value: (equipamento.medProtecao),
        callback: function($$v) {
          _vm.$set(equipamento, "medProtecao", $$v)
        },
        expression: "equipamento.medProtecao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "condFuncto"
      },
      model: {
        value: (equipamento.condFuncto),
        callback: function($$v) {
          _vm.$set(equipamento, "condFuncto", $$v)
        },
        expression: "equipamento.condFuncto"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "usoInint"
      },
      model: {
        value: (equipamento.usoInint),
        callback: function($$v) {
          _vm.$set(equipamento, "usoInint", $$v)
        },
        expression: "equipamento.usoInint"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "przValid"
      },
      model: {
        value: (equipamento.przValid),
        callback: function($$v) {
          _vm.$set(equipamento, "przValid", $$v)
        },
        expression: "equipamento.przValid"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "periodicTroca"
      },
      model: {
        value: (equipamento.periodicTroca),
        callback: function($$v) {
          _vm.$set(equipamento, "periodicTroca", $$v)
        },
        expression: "equipamento.periodicTroca"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-input-switch', {
      attrs: {
        "name": "higienizacao"
      },
      model: {
        value: (equipamento.higienizacao),
        callback: function($$v) {
          _vm.$set(equipamento, "higienizacao", $$v)
        },
        expression: "equipamento.higienizacao"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-top": "solid 1px #cccccc"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-times",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEPI(index)
        }
      }
    })], 1)])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          INFORMAÇÕES DA MEDIÇÃO\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.lancamentos),
      expression: "config.loading.lancamentos"
    }],
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.formData.id_tab) ? _c('div', {}, _vm._l((_vm.config.list.lancamentos), function(coluna, i) {
    return _c('div', {
      key: i,
      staticClass: "col-12 text-left p-0 mb-2"
    }, [(_vm.showCategoria(coluna, i)) ? _c('div', {
      style: ('font-weight: bold;')
    }, [(coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.tabela_categoria.nome) + "\n                ")]) : (!coluna.tabela_categoria) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 217) ? _c('ed-button', {
      attrs: {
        "icon": "fa fa-plus-circle",
        "type": "text",
        "value": "Inserir Nova Linha"
      },
      on: {
        "click": function($event) {
          return _vm.onInserirLinha(coluna, i)
        }
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: 'col-12 p-0 mt-1 mb-1'
    }, [(
      coluna.tipo_campo.id == 208 || coluna.tipo_campo.id == 216
    ) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (coluna.mascara ? coluna.mascara : ''),
        expression: "coluna.mascara ? coluna.mascara : ''"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 215) ? _c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      attrs: {
        "type": coluna.tipo_campo.valor
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, [(coluna.unidade) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(coluna.unidade))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 209) ? _c('el-input-number', {
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('span', [_vm._v("\n                  " + _vm._s(coluna.nome) + "\n                ")]) : _vm._e(), _vm._v(" "), (coluna.tipo_campo.id == 210) ? _c('el-select', {
      attrs: {
        "clearable": true,
        "placeholder": "Selecione"
      },
      model: {
        value: (coluna.valor),
        callback: function($$v) {
          _vm.$set(coluna, "valor", $$v)
        },
        expression: "coluna.valor"
      }
    }, _vm._l((coluna.tabela_valores), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.nome,
          "value": item.id
        }
      })
    }), 1) : _vm._e()], 1), _vm._v(" "), (
      coluna.tabela_valores.length > 0 &&
      coluna.tipo_campo.id != 210
    ) ? _c('div', {
      staticClass: "row"
    }, _vm._l((coluna.tabela_valores), function(coluna_val, j) {
      return _c('div', {
        key: i + j,
        class: 'col-' +
          12 / coluna.tabela_valores.length +
          ' text-left mb-2'
      }, [_vm._v("\n                  " + _vm._s(coluna_val.nome) + "\n                  "), (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        (coluna_val.tipo_campo.id == 208 ||
          coluna_val.tipo_campo.id == 216)
      ) ? _c('el-input', {
        attrs: {
          "type": coluna_val.tipo_campo ?
            coluna_val.tipo_campo.valor :
            'text'
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 215
      ) ? _c('el-input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('money'),
          expression: "'money'"
        }],
        attrs: {
          "type": "text"
        },
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }, [(coluna_val.unidade) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(coluna_val.unidade))]) : _vm._e()], 2) : (
        coluna.tipo_campo.id != 217 &&
        coluna_val.tipo_campo &&
        coluna_val.tipo_campo.id == 209
      ) ? _c('el-input-number', {
        model: {
          value: (coluna_val.valor),
          callback: function($$v) {
            _vm.$set(coluna_val, "valor", $$v)
          },
          expression: "coluna_val.valor"
        }
      }) : _vm._e(), _vm._v(" "), _vm._l((coluna_val.linhas), function(coluna_val_lin, k) {
        return _c('div', {
          key: i + j + k,
          class: 'col-12 text-left p-0 mt-2'
        }, [(j == 0 && k > 0) ? _c('span', [_c('el-link', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.onDeleteLinha(coluna, k)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v("\n                        Remover Linha\n                      ")])], 1) : (k > 0) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (
          coluna_val_lin.tipo_campo &&
          (coluna_val_lin.tipo_campo.id == 208 ||
            coluna_val_lin.tipo_campo.id == 216)
        ) ? _c('el-input', {
          attrs: {
            "type": coluna_val_lin.tipo_campo ?
              coluna_val_lin.tipo_campo.valor :
              'text'
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 215
        ) ? _c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "type": "text"
          },
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }, [(coluna_val_lin.unidade) ? _c('template', {
          slot: "append"
        }, [_vm._v(_vm._s(coluna_val_lin.unidade))]) : _vm._e()], 2) : (
          coluna_val_lin.tipo_campo &&
          coluna_val_lin.tipo_campo.id == 209
        ) ? _c('el-input-number', {
          model: {
            value: (coluna_val_lin.valor),
            callback: function($$v) {
              _vm.$set(coluna_val_lin, "valor", $$v)
            },
            expression: "coluna_val_lin.valor"
          }
        }) : _vm._e()], 1)
      })], 2)
    }), 0) : _vm._e(), _vm._v(" "), (
      _vm.response.status == 400 &&
      _vm.response.options.data[0] &&
      _vm.response.options.data[0][coluna.id]
    ) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "color": "#e66666",
        "font-size": "9pt"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.response.options.data[0][coluna.id]) + "\n              ")]) : _vm._e()])
  }), 0) : _vm._e()])], 1), _vm._v(" "), (
    !_vm.config.loading.content &&
    !_vm.config.loading.lancamentos &&
    (!_vm.formData.id_age || !_vm.formData.id_tab)
  ) ? _c('ed-alert', {
    attrs: {
      "type": "warning",
      "title": "Selecione todos os campos obrigatórios"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Medição",
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatRisco,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eeb0b9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/ghe/medicao.vue
// module id = 1566
// module chunks = 45